import { ConsignmentRootDataContext } from 'Pages/UserDashboard/Consignment/Contexts/ConsignmentRootData';
import { useOutsideAlerter } from 'helpers/dom';
import { handleCategoryTextConverter } from 'helpers/textConverter';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { IconContext } from 'react-icons';
import { CgOptions } from 'react-icons/cg';

const Filter: React.FC = () => {
  const consignmentContext = useContext(ConsignmentRootDataContext);
  const form = consignmentContext.value.formTabToolbar;
  const [isFilterOpen, setFilterOpen] = useState(false);
  const [categorySelected, setCategorySelected] = useState({
    sneakers: false,
    apparel: false,
    luxury: false,
    toys: false,
    'local-brands': false,
  });

  const onChangeCategory = (val: boolean, key: string) => {
    setCategorySelected({
      ...categorySelected,
      [key]: val,
    });
  };
  const wrapperRefFilter = useRef(null);
  useOutsideAlerter(wrapperRefFilter, () => setFilterOpen(false));
  const toggleFilter = () => setFilterOpen(!isFilterOpen);

  useEffect(() => {
    let selectedCategory = '';
    const selectedCategoryArray: string[] = [];
    Object.keys(categorySelected).forEach((t, index, array) => {
      if (categorySelected[t]) {
        selectedCategoryArray.push(handleCategoryTextConverter(t));
      }
      if (index === array.length - 1) {
        selectedCategory = selectedCategoryArray.join(',');
      }
    });
    form?.setFieldValue('category', selectedCategory);
    form?.setFieldValue('page', 1);
  }, [categorySelected]);

  return (
    <div className={'filter-container'} ref={wrapperRefFilter}>
      <div className={'filter-parent'} onClick={toggleFilter}>
        <IconContext.Provider value={{ color: '#242424', size: '20px' }}>
          <div>
            <CgOptions />
          </div>
        </IconContext.Provider>
        <span className={'text'}>Filter</span>
      </div>

      {isFilterOpen && (
        <div className={`filter-pop-up`}>
          <div className={'filter-item-category'}>
            <p className={'title'}>Category</p>
            <div className={'filter-item'}>
              <div className="pretty p-svg p-curve">
                <input
                  type="checkbox"
                  checked={categorySelected.sneakers}
                  onChange={(e) => {
                    onChangeCategory(e.target.checked, 'sneakers');
                  }}
                />
                <div className="state">
                  <svg className="svg svg-icon" viewBox="0 0 20 20">
                    <path
                      d="M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z"
                      style={{ stroke: 'white', fill: 'white' }}
                    ></path>
                  </svg>
                  <label>Sneakers</label>
                </div>
              </div>
            </div>
            <div className={'filter-item'}>
              <div className="pretty p-svg p-curve">
                <input
                  type="checkbox"
                  onChange={(e) => {
                    onChangeCategory(e.target.checked, 'apparel');
                  }}
                  checked={categorySelected.apparel}
                />
                <div className="state">
                  <svg className="svg svg-icon" viewBox="0 0 20 20">
                    <path
                      d="M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z"
                      style={{ stroke: 'white', fill: 'white' }}
                    ></path>
                  </svg>
                  <label>Apparel</label>
                </div>
              </div>
            </div>
            <div className={'filter-item'}>
              <div className="pretty p-svg p-curve">
                <input
                  type="checkbox"
                  onChange={(e) => {
                    onChangeCategory(e.target.checked, 'luxury');
                  }}
                  checked={categorySelected.luxury}
                />
                <div className="state">
                  <svg className="svg svg-icon" viewBox="0 0 20 20">
                    <path
                      d="M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z"
                      style={{ stroke: 'white', fill: 'white' }}
                    ></path>
                  </svg>
                  <label>Luxury</label>
                </div>
              </div>
            </div>
            <div className={'filter-item'}>
              <div className="pretty p-svg p-curve">
                <input
                  type="checkbox"
                  onChange={(e) => {
                    onChangeCategory(e.target.checked, 'toys');
                  }}
                  checked={categorySelected.toys}
                />
                <div className="state">
                  <svg className="svg svg-icon" viewBox="0 0 20 20">
                    <path
                      d="M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z"
                      style={{ stroke: 'white', fill: 'white' }}
                    ></path>
                  </svg>
                  <label>Electronics & Collectibles</label>
                </div>
              </div>
            </div>
            <div className={'filter-item'}>
              <div className="pretty p-svg p-curve">
                <input
                  type="checkbox"
                  onChange={(e) => {
                    onChangeCategory(e.target.checked, 'local-brands');
                  }}
                  checked={categorySelected['local-brands']}
                />
                <div className="state">
                  <svg className="svg svg-icon" viewBox="0 0 20 20">
                    <path
                      d="M7.629,14.566c0.125,0.125,0.291,0.188,0.456,0.188c0.164,0,0.329-0.062,0.456-0.188l8.219-8.221c0.252-0.252,0.252-0.659,0-0.911c-0.252-0.252-0.659-0.252-0.911,0l-7.764,7.763L4.152,9.267c-0.252-0.251-0.66-0.251-0.911,0c-0.252,0.252-0.252,0.66,0,0.911L7.629,14.566z"
                      style={{ stroke: 'white', fill: 'white' }}
                    ></path>
                  </svg>
                  <label>Made in Indonesia</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Filter;
